import React, {useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import {useDispatch, useSelector} from "react-redux";
import {Link, useRouteMatch} from "react-router-dom";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";

export default function ViewEmployee() {
  const employeeList = useSelector((state) => state.Utilities.Employee);
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const [showModal, SetshowModal] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  const [filterText, setFilterText] = useState("");

  const FetchemployeeData = () => {
    ApiConnect.get(`/Module/Utilities/Employee/Details`)
      .then((response) => {
        let Employee = response.data;
        dispatch({ type: "SET_UTILITIES_EMPLOYEE", payload: { Employee } });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    FetchemployeeData();
  }, []);
  const columns = [
    {
      name: "Name",
      selector: row => row.name,
      sortable: true,
      cell: (row) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={row.image}
              alt={row.name}
            />
            <div className="media-body">
              <p className="lh-1">
                {row.name}
                <small className="sidetitle">{row.position}</small>
              </p>
              <small>{row.id}</small>
            </div>
          </div>
        );
      },
    },
    {
      name: "M/F",
      selector: row => row.gender,
      sortable: true,
    },
    {
      name: "B.G",
      selector: row => row.blood,
      sortable: true,
    },
    {
      name: "Joining",
      selector: row => row.joining,
      sortable: true,
      cell: (row) => {
        return (
          <React.Fragment>
            {row.joining}-{row.leaving}
          </React.Fragment>
        );
      },
    },
    {
      name: "Department",
      selector: row => row.department,
      sortable: true,
    },
    {
      name: "Address",
      selector: row => row.address,
      sortable: true,
    },
    {
      name: "Contact",
      selector: row => row.contact,
      sortable: true,
      cell: (row) => {
        return <a href={`tel:${row.contact}`}>{row.contact}</a>;
      },
    },
    {
      name: "Action",
      selector: row => row.action,
      className: "table-actions",
      width: "150px",
      sortable: false,
      cell: (row) => {
        return (
          <React.Fragment>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/Edit/${row.id}`}
            >
              <span className="material-icons-outlined">edit_note</span>
            </Link>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetshowModal(true);
                SetselectedId(row.id);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = employeeList.filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <div className="card-body">
          <div className="dataTables_wrapper">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={e => setFilterText(e.target.value)}
              />
            </div>
            <DataTable
              className="table table-separated"
              keyField="id"
              columns={columns}
              data={filteredData}
              pagination
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
              paginationPerPage={10}
              customStyles={customStyles}
              filter
              exportable
            />
          </div>
          <DeletePop
            trigger={showModal}
            delUrl={`/Module/Utilities/Employee/DeleteEmployee?id=${selectedId}`}
            hideTrigger={SetshowModal}
            fallAction={FetchemployeeData}
          />
        </div>
      </div>
    </div>
  );
}